import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e71e04c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "enkrypt-banner left"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Multi-chain web3 extension.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Use Ethereum and Polkadot networks with its Parachains in single wallet. ", -1))
const _hoisted_4 = {
  key: 1,
  class: "enkrypt-banner"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Enkrypt: multi-chain web3 extension.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Enkrypt is a wallet extension that allows you to use all networks. Most popular ones, like Ethereum and Polkadot with its Parachains are already built in. ", -1))

import BaseButton from "@/components/base-button/index.vue";
import EnkryptLogoWhite from "@/icons/common/enkrypt-logo-white.vue";
import { extension } from "@/stores";
import { getBrowserName, extensionUrl } from "@/utils/browser";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isLeft: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



const action = () => {
  window.open(extensionUrl[browserName], "_blank");
};

const browserName = getBrowserName();

return (_ctx: any,_cache: any) => {
  return (__props.isLeft)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(EnkryptLogoWhite),
        _hoisted_2,
        _hoisted_3,
        _createVNode(BaseButton, {
          title: "Get extenion",
          small: true,
          action: action
        })
      ], 512)), [
        [_vShow, _unref(extension)?.name != 'enkrypt']
      ])
    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(BaseButton, {
          title: `Get on ${_unref(browserName)} web store`,
          action: action
        }, null, 8, ["title"])
      ], 512)), [
        [_vShow, _unref(extension)?.name != 'enkrypt']
      ])
}
}

})